import React, { useState } from "react";
import styles from "../styles/Pacientes.module.css";
import { handlePacienteSubmit } from "../handlers/pacientes";

const NuevoPacienteModal = ({ show, onClose }) => {
  // Estados para Owner
  const [owner, setOwner] = useState({
    full_name: "",
    rut: "",
    mail: "",
    phone: "",
    address: "",
    photo: "",
    photoPreview: undefined,
  });

  // Estados para Patient
  const [patient, setPatient] = useState({
    name: "",
    species: "",
    breed: "",
    age: "",
    chip: "",
    photo: "",
    photoPreview: undefined,
  });

  const token = localStorage.getItem("token");
  const [message, setMessage] = useState("");

  // Handlers
  const handleOwnerChange = (e) => {
    setOwner({ ...owner, [e.target.name]: e.target.value });
  };

  const handlePatientChange = (e) => {
    setPatient({ ...patient, [e.target.name]: e.target.value });
  };

  if (!show) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
          <button className={styles.closeButton} onClick={onClose} title="Cerrar">
            ×
          </button>
        <form
          className={styles.pacientesForm}
          onSubmit={(e) =>
            handlePacienteSubmit({
              e,
              owner,
              token,
              patient,
              setMessage,
              setOwner,
              setPatient,
            })
          }
        >
          <h4 className={styles.sectionTitle}>Datos del Propietario</h4>
          <div className={styles.formRow}>
            <label className={styles.imagePreviewLabel}>
              <div className={styles.imagePreview}>
                {owner.photoPreview ? (
                  <img src={owner.photoPreview} alt="Foto propietario" />
                ) : (
                  <span style={{ color: "#aaa", fontSize: "1rem" }}>No image</span>
                )}
                <input
                  type="file"
                  name="photo"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setOwner({ ...owner, photo: file });
                    if (file) {
                      const reader = new FileReader();
                      reader.onload = (ev) =>
                        setOwner((prev) => ({
                          ...prev,
                          photoPreview: ev.target.result,
                        }));
                      reader.readAsDataURL(file);
                    } else {
                      setOwner((prev) => ({
                        ...prev,
                        photoPreview: undefined,
                      }));
                    }
                  }}
                  className={styles.fileInput}
                />
              </div>
            </label>
            <div className={styles.formFields}>
              <input
                type="text"
                name="full_name"
                placeholder="Nombre completo"
                value={owner.full_name}
                onChange={handleOwnerChange}
                required
                className={styles.input}
              />
              <input
                type="text"
                name="rut"
                placeholder="RUT"
                value={owner.rut}
                onChange={handleOwnerChange}
                className={styles.input}
              />
              <input
                type="text"
                name="mail"
                placeholder="Correo"
                value={owner.mail}
                onChange={handleOwnerChange}
                className={styles.input}
              />
              <input
                type="text"
                name="phone"
                placeholder="Teléfono"
                value={owner.phone}
                onChange={handleOwnerChange}
                className={styles.input}
              />
              <input
                type="text"
                name="address"
                placeholder="Dirección"
                value={owner.address}
                onChange={handleOwnerChange}
                className={styles.input}
              />
            </div>
          </div>

          <h4 className={styles.sectionTitle}>Datos del Paciente</h4>
          <div className={styles.formRow}>
            <label className={styles.imagePreviewLabel}>
              <div className={styles.imagePreview}>
                {patient.photoPreview ? (
                  <img src={patient.photoPreview} alt="Foto paciente" />
                ) : (
                  <span style={{ color: "#aaa", fontSize: "1rem" }}>No image</span>
                )}
                <input
                  type="file"
                  name="photo"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setPatient({ ...patient, photo: file });
                    if (file) {
                      const reader = new FileReader();
                      reader.onload = (ev) =>
                        setPatient((prev) => ({
                          ...prev,
                          photoPreview: ev.target.result,
                        }));
                      reader.readAsDataURL(file);
                    } else {
                      setPatient((prev) => ({
                        ...prev,
                        photoPreview: undefined,
                      }));
                    }
                  }}
                  className={styles.fileInput}
                />
              </div>
            </label>
            <div className={styles.formFields}>
              <input
                type="text"
                name="name"
                placeholder="Nombre"
                value={patient.name}
                onChange={handlePatientChange}
                required
                className={styles.input}
              />
              <input
                type="text"
                name="species"
                placeholder="Especie"
                value={patient.species}
                onChange={handlePatientChange}
                required
                className={styles.input}
              />
              <input
                type="text"
                name="breed"
                placeholder="Raza"
                value={patient.breed}
                onChange={handlePatientChange}
                className={styles.input}
              />
              <input
                type="number"
                name="age"
                placeholder="Edad"
                value={patient.age}
                onChange={handlePatientChange}
                className={styles.input}
              />
              <input
                type="number"
                name="chip"
                placeholder="Chip"
                value={patient.chip}
                onChange={handlePatientChange}
                className={styles.input}
              />
            </div>
          </div>

          <button type="submit" className={styles.button}>
            Registrar Paciente
          </button>
          {message && <p className={styles.message}>{message}</p>}
        </form>
      </div>
    </div>
  );
};

export default NuevoPacienteModal;